var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTextArea01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 30.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.9313 31.2187)",
    width: 10.3,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1,
    y: 23.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.1936 24.6094)",
    width: 29,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.8,
    y: 16.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.4558 18)",
    width: 47.6,
    height: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTextArea01);
export default __webpack_public_path__ + "static/media/ico-text-area-01.fa8e0df121fd39cbff452de275d5733f.svg";
export { ForwardRef as ReactComponent };